import { render, staticRenderFns } from "./GuestSelectionModal.vue?vue&type=template&id=2bbcb4f8&scoped=true"
import script from "./GuestSelectionModal.vue?vue&type=script&lang=js"
export * from "./GuestSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./GuestSelectionModal.vue?vue&type=style&index=0&id=2bbcb4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcb4f8",
  null
  
)

export default component.exports